
export const getSubscriptionStatusKey = (status: string): string => {
  switch (status?.toUpperCase()) {
      case 'ACTIVE':
        return 'subscription.status.active';
      case 'CANCELED':
      case 'CANCELLED':
        return 'subscription.status.canceled';
      default:
        console.log('Debug - falling back to unknown for status:', status);
        return 'subscription.status.unknown';
    }
};
